var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrowserEmbed = function SvgBrowserEmbed(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.34 70",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor;fill-opacity:.38;}.cls-2,.cls-3{fill:currentColor;}.cls-2{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741,364.06H691v-10h48.33a1.55,1.55,0,0,1,.64.12,1.65,1.65,0,0,1,.54.36,1.69,1.69,0,0,1,.49,1.18Z",
    transform: "translate(-661.01 -350.73)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M666,350.73h73.34a5,5,0,0,1,5,5v60a5,5,0,0,1-5,5H666a5,5,0,0,1-5-5v-60a5,5,0,0,1,5-5Zm0,3.34a1.77,1.77,0,0,0-.64.12,2,2,0,0,0-.54.36,1.76,1.76,0,0,0-.36.54,1.78,1.78,0,0,0-.13.64v8.32h23.34v-10Zm75,61.66a1.56,1.56,0,0,1-.13.64,1.65,1.65,0,0,1-.9.9,1.56,1.56,0,0,1-.64.13H666a1.69,1.69,0,0,1-1.18-.49,1.65,1.65,0,0,1-.36-.54,1.74,1.74,0,0,1-.13-.64V367.4H741Zm-50-51.67h50v-8.31a1.69,1.69,0,0,0-.49-1.18,1.82,1.82,0,0,0-.54-.36,1.73,1.73,0,0,0-.64-.12H691Z",
    transform: "translate(-661.01 -350.73)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M671,357.4h-3.33v3.34H671Z",
    transform: "translate(-661.01 -350.73)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M677.68,357.4h-3.34v3.34h3.34Z",
    transform: "translate(-661.01 -350.73)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M684.35,357.4H681v3.34h3.34Z",
    transform: "translate(-661.01 -350.73)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M697.63,408.76a1.6,1.6,0,0,1-.53-.09,1.63,1.63,0,0,1-1-2.07l10.09-29.47a1.65,1.65,0,0,1,.83-.93,1.62,1.62,0,0,1,1.24-.08,1.64,1.64,0,0,1,.94.83,1.66,1.66,0,0,1,.07,1.24l-10.09,29.47a1.61,1.61,0,0,1-1.54,1.1Z",
    transform: "translate(-661.01 -350.73)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M727.35,391.25,717,380.91a1.63,1.63,0,1,0-2.3,2.3l9.18,9.19-9.18,9.18a1.62,1.62,0,0,0-.48,1.15,1.63,1.63,0,0,0,2.78,1.15l10.34-10.34a1.61,1.61,0,0,0,.47-1.14A1.64,1.64,0,0,0,727.35,391.25Z",
    transform: "translate(-661.01 -350.73)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M678,391.25l10.34-10.34a1.63,1.63,0,1,1,2.3,2.3l-9.18,9.19,9.18,9.18a1.62,1.62,0,0,1,.48,1.15,1.63,1.63,0,0,1-2.78,1.15L678,393.55a1.58,1.58,0,0,1-.35-.53,1.67,1.67,0,0,1-.12-.62,1.63,1.63,0,0,1,.12-.62A1.58,1.58,0,0,1,678,391.25Z",
    transform: "translate(-661.01 -350.73)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrowserEmbed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/browser-embed.166657237c29065f954bd1b3def01f13.svg";